// @flow

import { createContext, useContext } from 'react';
import { type Tenant } from './tenant';

const TenantContext = createContext<?Tenant>(null);

export const TenantProvider = TenantContext.Provider;

export function useTenant(): Tenant {
  const tenant = useContext(TenantContext);
  if (!tenant) {
    throw new Error('Tenant is not provided');
  }
  return tenant;
}
